import { Seo } from "@/components/Seo";
import { Reveal, SectionHead, Tag, Dot, KV } from "@/components/System";
import { AGENTS } from "@/data/content";

const Agents = () => (
    <div>
        <Seo path="/agents" />
        <section className="relative overflow-hidden px-4 pb-16 pt-36 sm:px-6">
            <div className="vm-grid-bg pointer-events-none absolute inset-0 opacity-30" aria-hidden="true" />
            <div className="relative mx-auto max-w-7xl">
                <div className="vm-micro mb-6 flex flex-wrap items-center gap-3">
                    AGENTVM://AGENTS <Tag tone="concept">ILLUSTRATIVE PROFILES</Tag>
                </div>
                <h1 className="max-w-4xl text-4xl font-bold tracking-tight text-[#F5F9FF] sm:text-6xl">
                    AGENTS ARE BECOMING
                    <br />
                    <span className="text-[#00D9FF] vm-glow">ECONOMIC ACTORS.</span>
                </h1>
                <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#B8C7D9] sm:text-lg">
                    Every agent in the AgentVM model carries the same system anatomy: identity, mission, permissions,
                    private data, runtime, proof, and action. These profiles illustrate the pattern — they are design
                    references, not live workloads.
                </p>
            </div>
        </section>

        <section className="mx-auto max-w-7xl px-4 pb-24 sm:px-6" data-testid="agents-grid">
            <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
                {AGENTS.map((a, i) => (
                    <Reveal key={a.code} delay={(i % 3) * 0.08}>
                        <div
                            data-testid={`agent-${a.code.toLowerCase()}`}
                            className="group vm-panel flex h-full flex-col transition-colors duration-300 hover:border-[#00D9FF]/40"
                        >
                            <div className="flex items-center justify-between border-b border-[rgba(0,217,255,0.12)] px-4 py-2.5">
                                <span className="font-mono text-[10px] tracking-[0.22em] text-[#00D9FF]/80">{a.code}</span>
                                <span className="flex items-center gap-2 font-mono text-[9px] tracking-[0.18em] text-[#B8C7D9]/60">
                                    <Dot tone="dim" /> PROFILE
                                </span>
                            </div>
                            <div className="flex flex-1 flex-col p-5">
                                <h2 className="font-mono text-base tracking-[0.14em] text-[#F5F9FF] group-hover:text-[#00D9FF]">{a.name}</h2>
                                <p className="mt-3 text-xs leading-relaxed text-[#B8C7D9]/85">{a.mission}</p>
                                <div className="mt-5 flex-1 space-y-1 border-t border-[rgba(0,217,255,0.1)] pt-4">
                                    <KV k="PERMISSIONS" v={a.permissions.join(" · ")} />
                                    <KV k="PRIVATE DATA" v={a.privateData} />
                                    <KV k="RUNTIME" v={a.runtime} tone="cyan" />
                                    <KV k="PROOF" v={a.proof} tone="ok" />
                                </div>
                                <div className="mt-4 border-t border-[rgba(0,217,255,0.1)] pt-3">
                                    <span className="vm-micro-dim">ACTION: </span>
                                    <span className="font-mono text-[10px] tracking-[0.1em] text-[#F5F9FF]/80">{a.action}</span>
                                </div>
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>
        </section>
    </div>
);

export default Agents;
